<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
      <z-page :title="title">
     <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
         <center>
          <div class="xs4" >
            <vueper-slides fade :touchable="false" fixed-height="300px">
                 <vueper-slide v-for="(slide, i) in slides" :key="i" :image="slide.image" fit="contain" />
               </vueper-slides>
                  <template v-if="$zutil.anyRole(['1', '3', '7', '9', '4', '8', '10', '11'])">
                     <w-input class="mt4" type="file" :preview="false" accept=" image/*" v-model="img" multiple @input="previewImages">Muat Naik Gambar</w-input>
                     <template v-for="dt, ind  in attahecmentImg">
                        <div class="fw-normal my1 fs-1">  
                        <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                        </div>
                     </template>
                  </template>
               <br><br>
             </div>
         </center>
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <z-select class="mt4" :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form.lkp_ternakan_id" @input="getJurusan(form.lkp_ternakan_id)" :validators="[validators.required]"/>
            <z-select class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan *"  v-model="form.lkp_jurusan_id" @input="getBaka(form.lkp_jurusan_id)" :validators="[validators.required]"/>
            <z-select class="mt4" :items="lkp_baka" label="Baka *"  v-model="form.lkp_baka_id"  :validators="[validators.required]"/>
            <z-select class="mt4" :items="lkp_gred" label="Generasi "  v-model="form.lkp_gred_id" />
            <z-select class="mt4" :items="jantina" label="Jantina *"  v-model="form.jantina"  :validators="[validators.required]" disabled/>
            <z-select class="mt4" :items="kepemilikan" label="Kepemilikan *"  v-model="form.kepemilikan"  :validators="[validators.required]"/>
            <z-select class="mt4" :items="lkp_negara" label="Negara Asal *"  v-model="form.lkp_negara_id"  :validators="[validators.required]"/>
            <w-textarea class="mt4"  label="Kegunaan Utama"  v-model="form.kegunaan" rows="4" />
             <z-select class="mt4" :items="lkp_status" label="Status *"  v-model="form.lkp_status_id"  :validators="[validators.required]" v-if="form.id > 0"/>
            <br>
            
          </div>
          <div class="mx2"></div>
          <div class="grow " >
            <br>
            <w-input label="ID Ternakan *" type="text" v-model="form.kode"  :validators="[validators.required]"/>
            <w-input class="mt4" label="Nama Ternakan " type="text" v-model="form.nama" />
            <w-input class="mt4" label="Tarikh Lahir *" type="date" v-model="form.tarikh_lahir" :validators="[validators.required]"/>
            <w-input class="mt4" label="Nama Bapa" type="text" v-model="form.nama_bapa" />
            <w-input class="mt4" label="ID Bapa" type="text" v-model="form.id_bapa" />
            <w-input class="mt4" label="Nama Ibu" type="text" v-model="form.nama_ibu" />
            <w-input class="mt4" label="ID Ibu" type="text" v-model="form.id_ibu" />
            <div class="ciri-ciri-container">
            <w-textarea class="mt4"  label="Ciri-ciri (Contoh: Berat, Saiz Skrotum, Kadar Kenaikan Berat Badan, Nilai Biak, etc...)"  v-model="form.ciri_ciri" rows="4" />
            </div>
            <div class="grow " >
            <template v-if="$zutil.anyRole(['1', '3', '7', '9', '11'])">
              <w-input class="mt4" type="file" :preview="false" accept="application/pdf" v-model="files" multiple>Muat Naik Sijil Pedigree dan Prestasi PDF</w-input>
            <template v-for="dt, ind  in attahecment">
                <div class="fw-normal my1 fs-1">  
                  <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecment(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                </div>
              </template>
            </template>
            <br><br>
          </div>
          </div>
         </div>
       <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '3', '7', '8', '9', '10', '4', '11'])">
               <w-button class="my1" v-on="on"  :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
                    <w-icon class="mr1" md >fal fa-save</w-icon>SIMPAN
                </w-button>
            &nbsp;
                   <w-button class="my1" bg-color="success" v-on="on" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
                    <w-icon class="mr1" md >fal fa-paper-plane</w-icon>HANTAR
                </w-button>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </w-form>
      </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide
  },
  props: {
    d_form: [Array, Object],
    d_kategori : [Array, Object],
    d_ternakan : [Array, Object],
    d_jurusan : [Array, Object],
    d_baka : [Array, Object],
    d_negara : [Array, Object],
    d_gred : [Array, Object],
    d_status : [Array, Object],
    d_jantina : [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.katalog',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Katalog Pejantan', route: '/se/katalog' },
      ],
      title : 'Tambah Baka Jantan',
      form : this.d_form,
      kategori : this.d_kategori,
      lkp_ternakan : this.d_ternakan,
      lkp_jurusan : this.d_jurusan,
      lkp_baka : this.d_baka,
      lkp_negara : this.d_negara,
      lkp_gred : this.d_gred,
      lkp_status : this.d_status,
      jantina : this.d_jantina,
      files:[],
      img:[],
      attahecment:[],
      attahecmentImg:[],
      slides:[],
      kepemilikan: [
         {value: 1, label: "Tempatan", disabled:this.$zutil.anyRole(['7', '8', '9', '10', '4'])},
         {value: 2, label: "Luar Negara",}
      ],
    }
  },

  methods: {
   send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if(this.form.id){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if(this.files.length > 0){
                     this.uploadPDF(res.id);
                  }
                  if (this.img.length > 0) {
                     this.uploadImg(res.id)
                  }
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  else if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('se.katalog.show', this.form.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if(this.files.length > 0){
                     this.uploadPDF(res.id);
                  }
                  if (this.img.length > 0) {
                     this.uploadImg(res.id)
                  }
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(this.$route('se.katalog.show', res.id));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if(this.files.length > 0){
               this.uploadPDF(this.form.id);
            }
            if (this.img.length > 0) {
               this.uploadImg(this.form.id);
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('se.katalog.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('se.katalog.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if(this.files.length > 0){
               this.uploadPDF(res.id);
            }
            if (this.img.length > 0) {
               this.uploadImg(res.id)
            }
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            // this.$inertia.visit(window.route('se.katalog.index'));
            this.$inertia.visit(this.$route('se.katalog.form', res.id));

          })
        }
      } 
    },

    setJantina(id){
      this.form.jantina = id
    },

    getJurusan(i){
      this.form.lkp_jurusan_id = ''
      this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
        this.lkp_jurusan = res
      })
    },

    getBaka(i){
      this.form.lkp_baka_id = ''
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        this.lkp_baka = res
      })
    },

    previewImages() {
      if (this.img && this.img.length > 0) {
        const currentSlides = [...this.slides];
        
        this.img.forEach(file => {
          const previewUrl = URL.createObjectURL(file.file);
          currentSlides.push({
            title: file.name,
            image: previewUrl,
            isPreview: true, 
            file: file.file 
          });
        });
        this.slides = currentSlides;
      }
    },

    uploadImg(item) 
    {  
       let formData = new FormData();
       for (var b in this.img) 
       {
           formData.append("files["+b+"]", this.img[b].file);
       }
       formData.append("model",'\\App\\Model\\SeKatalog');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload', formData)
           .then((res) => {
               this.slides = this.slides.filter(slide => !slide.isPreview);
               this.getAttahecmentImg();
           })
           .catch((err) => {
               this.slides = this.slides.filter(slide => !slide.isPreview);
           })
           .finally(() => {});
   },

   
   deletelAttahecmentImg(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecmentImg();
       })
     }
   },

    getAttahecmentImg()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\SeKatalog'}).then(res => {
        this.attahecmentImg = res
        this.slides = [];
       for (var b in this.attahecmentImg) {
          this.slides.push({title: this.attahecmentImg[b].information, image: this.attahecmentImg[b].url})
       }
      })
    },

    getAttahecment()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\SeKatalogCiri'}).then(res => {
         this.attahecment = res
         // this.slides = [];
         // for (var b in this.attahecment) {
         //    this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
         // }
      })
    },

   tutup(){
         this.$inertia.visit(window.route('se.katalog.index'));
       },

    uploadPDF(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",'\\App\\Model\\SeKatalogCiri');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   
   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
       })
     }
   },
  },

  watch: {
  },
  mounted() {
    if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh = today.toISOString().split('T')[0];
    }
    if(this.form.id > 0)
    {
      this.getAttahecment()
      this.getAttahecmentImg()
      this.title = 'Kemaskini Katalog Pejantan '
    }
    else
    {
      this.title = 'Tambah Katalog Pejantan '
    }
  }
}
</script>